module.exports = __webpack_public_path__ + "img/message-text-circle-01.a728a4e5.svg";